<ng-container>
  <form [formGroup]="loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over leningen, voorschotten en garanties ten behoeve van
          bestuurders en commissarissen</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(0)">
          {{ this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de belangrijkste overige bepalingen van leningen, voorschotten en
          garanties ten behoeve van bestuurders en commissarissen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(1)">
          {{ this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 0">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsDisclosureFg"
                                                               [title]="'Informatieverschaffing over leningen, voorschotten en garanties ten behoeve van bestuurders en commissarissen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.loansAdvancesGuaranteesOnBehalfOfManagingSupervisoryDirectorsSignificantConditionsDescriptionFg"
                                                               [title]="'Beschrijving van de belangrijkste overige bepalingen van leningen, voorschotten en garanties ten behoeve van bestuurders en commissarissen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

